import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

export default function Cookies() {
  return (
    <main className="policy-page">
      <header className="policy-page__header">
        <p className="policy-page__eyebrow">LEGAL / {siteConfig.wordmark}</p>
        <h1>COOKIE<br />POLICY</h1>
        <p className="policy-page__lede">How local storage, cookies, and similar technologies support this store.</p>
      </header>
      <div className="policy-page__layout">
        <aside className="policy-page__toc"><p>RELATED</p><Link to="/privacy">PRIVACY POLICY</Link></aside>
        <article className="policy-page__content">
          <section className="policy-page__section"><span className="policy-page__section-number">01</span><h2>ESSENTIAL STORAGE</h2><p>We use browser storage required to keep your bag and wishlist available, maintain checkout state, and protect core site functionality.</p></section>
          <section className="policy-page__section"><span className="policy-page__section-number">02</span><h2>MEASUREMENT</h2><p>Where enabled and legally permitted, limited measurement tools may help us understand page reliability and general usage. Optional tools should follow the consent choice shown to you.</p></section>
          <section className="policy-page__section"><span className="policy-page__section-number">03</span><h2>YOUR CONTROLS</h2><p>You can remove or block stored data through your browser settings. Blocking essential storage may prevent the bag or checkout from working correctly.</p></section>
          <section className="policy-page__section"><span className="policy-page__section-number">04</span><h2>CONTACT</h2><p>Questions can be sent to <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.</p></section>
        </article>
      </div>
    </main>
  );
}
